import React from 'react';

export const containerStyles = {
    width: '100%',
    height: '100%',
    position: 'relative'
};

function LoadingViewPlaceHolder(props) {

    const loaderStyles = {
        backgroundColor: '#131313',
        width: '100%',
        overflow: 'hidden',
        position: props.container ? 'absolute' : 'relative',
        ...props.extraStyles
    };

    const loaderSwipeStyles = {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        background: 'linear-gradient(to right, #222222 10%, #808080 50%, #2c2c2c 80%)',
        animation: 'loaderSwipeAnim 1s cubic-bezier(0.4, 0.1, 0.2, 0.2) infinite',
        height: '100%'
    }

    return (
        <div style={loaderStyles}>
            <div style={loaderSwipeStyles}></div>
        </div>
    );
}

export default LoadingViewPlaceHolder;